import React, { useState, useEffect } from 'react';
import SelecionarCategoria from '../Utils/SelecionarCategoria';
import SelecionarTipoCategoria from '../Utils/TipoCategoria';
import { Form, Button, Card, Alert, Col, InputGroup} from 'react-bootstrap';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const CategoriaForm = () => {
    const navigate = useNavigate();
    const { id, tipo:t2 } = useParams();
    const [categoria, setCategoria] = useState(null);
    const [tipo, setTipo] = useState(t2);
    const [categoriaId, setCategoriaId] = useState(null);
    const [formErrors, setFormErrors] = useState([]);
    const { 
      setLinks, 
      setBtns,
      crud,
      salvarDados,
      buscarDadosPorId,
      setTitle,
    } = useProvider();
    const { patch, post, get, del, loading } = crud || {};
    const formData = new FormData();

    if(id) setTitle("Categoria");
    if(!id) setTitle("Nova Categoria");
    
    const handleDelete = () => {
      Swal.fire({
        title: "Tem certeza em excluir?",
        text: "Eata ação é definitiva, não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await del(`/gvendas/categorias/${id}/`);
            navigate(-1);
            Toast.fire({
                icon: "success",
                title: 'Categoria excluída com sucesso'
            });
          }catch(err){
            validarErrosApi(err);
          }
        }
      });
    }
    
    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
            ...(id ? [{ icon: 'bi-trash', onClick: handleDelete }] : []),
            { icon: 'bi-check-lg', onClick: handleSubmit }
        ]);
    
        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, id]); // Dependências ajustadas
    // Carrega o categorias ao editar
    useEffect(() => {
      if (id){
        carregarCategoriaLocal();
      }
    }, [id]);
    
  

    const carregarCategoriaLocal = async () => {
      try{
        const response = await buscarDadosPorId("db_categorias", parseInt(id));
        if(response){
          setCategoria(response);
          setTipo(response.tipo);
          setCategoriaId(response?.categoria_pai?.id || response?.categoria_pai);
        }
      }catch(err){
        
      }finally{
        carregarCategoria();
      }
    }
    const carregarCategoria = async () => {
        try {
            const response = await get(`/gvendas/categorias/${id}/?expand=categoria_pai`);
            if (response && response.length) {
                const item = response[0];
                setCategoria(item);
                setCategoriaId(item?.categoria_pai?.id);
                setTipo(item.tipo);
                await salvarDados("db_categorias", response[0]);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar categoria.' 
            : err.response?.data?.detail;
        
        if(err.response?.data?.detail){
            Toast.fire({
                icon: "error",
                title: err.response?.data?.detail
            });
        }
        //alert(JSON.stringify(err.response.data)
        setFormErrors(prevErrors => ({
            ...prevErrors,
            ...err.response?.data,
            apiError: errorMessage,
            nome_da_categoria: err.response?.data?.nome_da_categoria,
            descricao: err.response?.data?.descricao,
            marca: err.response?.data?.marca_id,
        }));
    };

    const handleSubmit = async (e) => {
        if(e) e.preventDefault();
        
        const errors = {};
        if (!categoria?.nome_da_categoria) errors.nome_da_categoria = 'Por favor, informe o nome da categoria.';
        if (!tipo) errors.tipo = 'Por favor, informe o tipo da categoria.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        
        setFormErrors({});

        
        formData.append('nome_da_categoria', categoria?.nome_da_categoria);
        formData.append('descricao', categoria?.descricao||``);
        formData.append('ncm', categoria?.ncm||``);
        formData.append('tipo', tipo||``);
        formData.append('categoria_pai', categoriaId || ``);
        
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(formData, `/gvendas/categorias/${id?id+'/':''}`, 'multipart/form-data');
            if (response && response.length) {
                //alert(JSON.stringify(response))
                Toast.fire({
                    icon: "success",
                    title: `Salvo com sucesso`
                });
                navigate(-1);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };
    

    return (
        <div className="">
              <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        {(!t2 && !id) && (<>
                          <SelecionarTipoCategoria tipo={tipo} setTipo={setTipo} obrigatorio={true}/>
                        </>)}
                        {formErrors.tipo && <Alert variant="danger">{formErrors.tipo}</Alert>}
                        <SelecionarCategoria categoriaId={categoriaId} tipo={tipo} setCategoriaId={setCategoriaId} label="Superior"/>
                        {formErrors.categoriaId && <Alert variant="danger">{formErrors.categoriaId}</Alert>}
                        <Form.Group controlId="formNome" className="mt-3">
                            <Form.Label>Nome da {categoriaId?`subcategoria`:`categoria`} *</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={categoria?.nome_da_categoria || ''} 
                                onChange={(e) => 
                                    setCategoria((prevCategoria) => ({
                                        ...prevCategoria,
                                        nome_da_categoria: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome_da_categoria && <Alert variant="danger">{formErrors.nome_da_categoria}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formNCM" className="mt-3">
                          <InputGroup>
                              <span className="input-group-text">NCM</span>
                              <Form.Control 
                                  type="text" 
                                  value={categoria?.ncm || ``} 
                                  onChange={(e) => setCategoria((prevItem) => ({
                                    ...prevItem,
                                    ncm: e.target.value
                                  }))}
                              />
                          </InputGroup>
                          {formErrors.ncm && <Alert variant="danger">{formErrors.ncm}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formDescricao" className="mt-3">
                            <Form.Label>Sobre a categoria</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={4}
                                value={categoria?.descricao || ''} 
                                onChange={(e) => 
                                    setCategoria((prevCategoria) => ({
                                        ...prevCategoria,
                                        descricao: e.target.value
                                    }))
                                }
                            />
                            {formErrors.descricao && <Alert variant="danger">{formErrors.descricao}</Alert>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {loading ? categoria ? "Salvando..." : 'Carregando...' : 'Salvar alterações'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};


export default CategoriaForm;